import { useEffect, useState } from "react";

const API_BASE = "https://dcbiomedical-api-357987547858.us-central1.run.app";
// const API_BASE = process.env.REACT_APP_API_BASE_URL;
export function usePublicInfo() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/public-info`)
      .then(res => res.json())
      .then(data => {
        setInfo(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch public info:", err);
        setLoading(false);
      });
  }, []);

  return { info, loading };
}
